function isCheckoutPage() {
  return window.location.pathname.includes('checkouts');
}

function setPreorderSettingsBackup() {
  const isGloboSettingsAvailable = !!(Globo && Globo.Preorder && Globo.Preorder.settings && Globo.Preorder.settings.preorderSettings && Globo.Preorder.settings.preorderSettings.products);
  if (isGloboSettingsAvailable) {
    localStorage.setItem("hellostore.preorder_settings_backup", JSON.stringify(Globo.Preorder.settings.preorderSettings));
    document.dispatchEvent(new CustomEvent("theme.preorder.settings-local-storage-ready"));
  }
}

if (!isCheckoutPage()) {
  setPreorderSettingsBackup();
}

function getPreorderSettingsBackup() {
  if (isCheckoutPage()) {
    const preorderSettings = localStorage.getItem('hellostore.preorder_settings_backup');
    if (preorderSettings) {
      return JSON.parse(preorderSettings);
    } else if (isPreorderCheckout) {
      window.location.assign(window.location.origin + "/cart");
    } else {
      return { products: {} };
    }
  } else {
    const isGloboSettingsAvailable = !!(Globo && Globo.Preorder && Globo.Preorder.settings && Globo.Preorder.settings.preorderSettings && Globo.Preorder.settings.preorderSettings.products);
    if (isGloboSettingsAvailable) {
      return Globo.Preorder.settings.preorderSettings;
    } else {
      return { products: {} };
    }
  }
}